import usePermission from '@/hooks/usePermission'

const PermissionWrapper = ({ permission, children }) => {
  const { hasPermission } = usePermission(permission)

  if (hasPermission) {
    return <>{children}</>
  }

  return null
}

export default PermissionWrapper
